import React from 'react'
import Home from '../home/Home'
import Layout from '../../common/Layout'

export default {

  path: '/find-an-ifa',

  async action () {
    return {
      title: 'Allan Gray | Find An Independent Financial Adviser',
      component: <Layout containerWell ><Home /></Layout>
    }
  }

}
